import { render, staticRenderFns } from "./Tr.vue?vue&type=template&id=d6681c46&"
import script from "./Tr.vue?vue&type=script&lang=js&"
export * from "./Tr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports